import React from "react";
import FormInput, { InputProps } from "Shared/Form/Input";
import styled from "styled-components";
import useSelector from "src/utils/useSelector";

const Input = styled(FormInput)`
    padding: 16px 10px 16px 20px;
`;

const Wrapper = styled("div")`
    position: relative;

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        appearance: none;
        margin: 0;
    }

    span {
        color: #aaa;
        font-size: 12px;
        left: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
`;

const DollarInput = (props: InputProps) => {
    const country = useSelector((state) => state.account.address?.country);

    return (
        <Wrapper>
            <span className="DollarInput__prefix">{country === "CA" ? "CA$" : "$"}</span>
            <Input {...props} type="number" />
        </Wrapper>
    );
};

export default DollarInput;
